export default __webpack_public_path__ + "static/media/day3_judges.38a09aba.jpg";